"use client";

import { ThemeProvider as NextThemesProvider } from "next-themes";
import type * as React from "react";
import { TooltipProvider } from "@/components/ui/tooltip";

export function ThemeProvider({
	children,
}: React.ComponentProps<typeof NextThemesProvider>) {
	return (
		<NextThemesProvider
			attribute="class"
			defaultTheme="light"
			storageKey="app-theme"
			enableSystem
			disableTransitionOnChange
			enableColorScheme
		>
			<TooltipProvider delayDuration={0}>{children}</TooltipProvider>
		</NextThemesProvider>
	);
}
